/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'navigation/back-white': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><g data-name="Layer 2"><g data-name="Layer 1-2"><path pid="0" _fill="#e25046" d="M0 0h34v34H0z"/><path pid="1" d="M17 27.5l10-8.87v-5l-8 7.1V6.5h-4v14.21l-8-7.1v5z" _fill="#fff"/></g></g></g></g>'
  }
})
